import React from 'react';
import Button from 'antd/lib/button';
import Modal from 'antd/lib/modal';
import { Flex } from '../../components/Flex';
import { Text } from '../../components/Text';
import {changeQueryString} from '.';

class Banner extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
    };
  }
  render() {
    return (
      <Flex flexDirection="column" width="100%">
        <Modal
          visible={this.state.showModal}
          title={null}
          closable={false}
          footer={null}
          onCancel={() => {
            // add step=account to URL
            const { search } = window.location;
            let searchString;
            if ( !search ) {
              searchString = '';
            } else if (search.indexOf('&modal=looking') !== -1){
              searchString = search.replace('&modal=looking', '');
            } else if (search.indexOf('?modal=looking') !== -1) {
              searchString = search.replace('?modal=looking', '');
            } else if (search.indexOf('modal=looking') !== -1) {
              searchString = search.replace('modal=looking', '');
            }
            changeQueryString(searchString, undefined, true);
            this.setState({ showModal: false });
          }}
        >
          <Text fontSize="16px" semibold mt={10} textAlign="center">
            We wish we could help!
          </Text>
          <p
            style={{
              marginTop: '20px',
              fontSize: '14px',
            }}
          >
            Workstream is for employers to post open positions, so we unfortunately can't help you
            find a job. The companies who post jobs through Workstream have positions listed on all
            the major job boards such as{' '}
            <a href="https://www.indeed.com/" target="_blank" rel="noopener noreferrer">
              Indeed.com
            </a>
            ,{' '}
            <a href="https://craigslist.org/" target="_blank" rel="noopener noreferrer">
              Craigslist
            </a>
            ,{' '}
            <a href="https://www.glassdoor.com/" target="_blank" rel="noopener noreferrer">
              Glassdoor
            </a>
            ,{' '}
            <a href="https://www.facebook.com/jobs" target="_blank" rel="noopener noreferrer">
              Facebook Jobs
            </a>
            , and more. Those are the best places we'd recommend to start - happy hunting!
          </p>
          <p
            style={{
              marginTop: '20px',
              fontSize: '14px',
            }}
          >
            - The Workstream team
          </p>
        </Modal>
        <Flex position="fixed" style={{ left: 0, right: 0, zIndex: 100 }} flexDirection="column">
        <Button
          type="primary"
          size="large"
          style={{ borderRadius: 0 }}
          onClick={() => {
            // add step=account to URL
            const { search } = window.location;
            let searchString;
            if ( !search ) {
              searchString = `?modal=looking`;
            } else if (search.indexOf('modal=looking') === -1){
              searchString = `${search}&modal=looking`;
            } else {
              searchString = search;
            }
            changeQueryString(searchString);
            this.setState({ showModal: true });
          }}
        >
          Looking for a job? Click here
        </Button>
        </Flex>
      </Flex>
    );
  }
}

export default Banner;
